import {
  LocalStorageKey,
  readLocalStorage,
  writeLocalStorage,
} from "@/lib/local-storage";
import type { AnalysisChatV2Id } from "@/utils/types";

const MAX_STORED_DRAFTS = 20;

const readAll = () =>
  readLocalStorage(LocalStorageKey.UnifiedChatDraftTexts, {});

export const readDraftText = (chatId: AnalysisChatV2Id): string =>
  readAll()[chatId] ?? "";

export const clearDraftTexts = () =>
  writeLocalStorage(LocalStorageKey.UnifiedChatDraftTexts, {});

export const writeDraftText = (chatId: AnalysisChatV2Id, text: string) => {
  const others = Object.entries(readAll()).filter(([id]) => id !== chatId);
  const entries: [string, string][] =
    text.length > 0 ? [...others, [chatId, text]] : others;
  writeLocalStorage(
    LocalStorageKey.UnifiedChatDraftTexts,
    Object.fromEntries(entries.slice(-MAX_STORED_DRAFTS))
  );
};
